import { getFeatureFlags } from "../services/config-service";
import { BaseModel } from "./base-model";

export enum FeatureFlagsEvents{
    featureBasedFlagsInitialized = 'featureBasedModelsInitialized'
}

// Flag names as served by configapi .../config/featureflags/enabled/<imo>. A feature is on when its
// name is present in that response's featureFlags array.
export const CONST_POW_ENDPOINT_V2 = "const_pow_endpoint_v2";

export abstract class FeatureFlagModelBase extends BaseModel
{
    abstract getFeatureFlags(): Promise<getFeatureFlags>;
    // Whether the flag is present in the feature flags response. Synchronous, for render paths:
    // it reads the response already fetched and returns false until the first one arrives, so
    // callers listen for 'featureFlagsUpdated' to re-render once the flags land.
    abstract hasFeatureFlag(flagName: string): boolean;
    abstract isFeatureEnabled(flagName: string): Promise<boolean>;
}

let FeatureFlagModel: FeatureFlagModelBase|null = null;

function setFeatureFlagModel(model: FeatureFlagModelBase)
{
    FeatureFlagModel = model;
}

export { FeatureFlagModel, setFeatureFlagModel };